module.exports = __webpack_public_path__ + "static/bannet-tv-perolas-coloridas-a2a739729793a649f420868edcf2f7a6.jpg";